// extracted by mini-css-extract-plugin
export default {"main":"CocktailIngredients_main__4vi1l"};